"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Schedule = void 0;
const zod_1 = require("zod");
const timestamp_1 = require("./timestamp");
exports.Schedule = zod_1.z.object({
    /**
     * Represents the time when the schedule should start. Must be a positive integer representing seconds since the Unix epoch.
     */
    from: timestamp_1.Timestamp,
    /**
     * Represents the time when the schedule should stop. Must be a positive integer representing seconds since the Unix epoch.
     * If omitted the ad set will run eternally (unless a subsequent update sets it to an explicit value)
     */
    to: timestamp_1.Timestamp.optional(),
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2NoZWR1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvZW50aXRpZXMvc2NoZWR1bGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXVCO0FBRXZCLDJDQUF1QztBQUUxQixRQUFBLFFBQVEsR0FBRyxPQUFDLENBQUMsTUFBTSxDQUFDO0lBQy9COztPQUVHO0lBQ0gsSUFBSSxFQUFFLHFCQUFTO0lBQ2Y7OztPQUdHO0lBQ0gsRUFBRSxFQUFFLHFCQUFTLENBQUMsUUFBUSxFQUFFO0NBQ3pCLENBQUMsQ0FBQSJ9